import { useEffect, useRef, useState } from 'react';

export const useDebouncedQuantity = (quantity: number, setIsWidgetMounted: (value: boolean) => void) => {
  const safeQuantity = quantity > 0 ? quantity : 1;
  const debounceTimeout = 1500;
  const [debouncedQuantity, setDebouncedQuantity] = useState(safeQuantity);
  const lastSafeQuantityRef = useRef(safeQuantity);

  useEffect(() => {
    const prevSafeQuantity = lastSafeQuantityRef.current;

    if (prevSafeQuantity === safeQuantity) return;

    lastSafeQuantityRef.current = safeQuantity;

    setIsWidgetMounted(false);

    const debounceTimeoutId = window.setTimeout(() => {
      setDebouncedQuantity(safeQuantity);

      if (lastSafeQuantityRef.current === safeQuantity) {
        const mountAfterDebounceTimeout = window.setTimeout(() => {
          setIsWidgetMounted(true);
        }, debounceTimeout);
        return () => clearTimeout(mountAfterDebounceTimeout);
      }
    }, debounceTimeout);

    return () => clearTimeout(debounceTimeoutId);
  }, [safeQuantity, setIsWidgetMounted]);

  return debouncedQuantity;
};
